
import { globalApiHandler } from "../../services/services";

export const getReportsData = (params) => {
    let url = `/ntrac/report/filter?${params}`
    return dispatch => {
        globalApiHandler(url, 'get', {}, dispatch).then((response) => {
            const data = response.data
            dispatch({ type: 'FILTERED_REPORTS_LIST', data: data.data })
            // dispatch({type: 'SERVER_SUCCESS', data: response.data})
            return true
        }).catch((err)=>{
            dispatch({type: 'SERVER_ERROR', data: err.data})
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/action.js